import { apiClient } from './client';
import { Workspace, WorkspaceMapping } from '../types';

export async function getWorkspaces(): Promise<Workspace[]> {
  return apiClient<Workspace[]>('/workspaces');
}

export async function getWorkspace(name: string): Promise<Workspace> {
  return apiClient<Workspace>(`/workspaces/${encodeURIComponent(name)}`);
}

export async function createWorkspace(
  data: Partial<Workspace>
): Promise<Workspace> {
  return apiClient<Workspace>('/workspaces', {
    method: 'POST',
    body: data,
  });
}

export async function updateWorkspace(
  name: string,
  data: Partial<Workspace>
): Promise<Workspace> {
  return apiClient<Workspace>(`/workspaces/${encodeURIComponent(name)}`, {
    method: 'PATCH',
    body: data,
  });
}

export async function deleteWorkspace(name: string): Promise<void> {
  return apiClient(`/workspaces/${encodeURIComponent(name)}`, {
    method: 'DELETE',
  });
}

export async function getMappings(): Promise<WorkspaceMapping[]> {
  return apiClient<WorkspaceMapping[]>('/config/mappings');
}

export async function createMapping(
  data: Partial<WorkspaceMapping>
): Promise<WorkspaceMapping> {
  return apiClient<WorkspaceMapping>('/config/mappings', {
    method: 'POST',
    body: data,
  });
}

export async function updateMapping(
  id: string,
  data: Partial<WorkspaceMapping>
): Promise<WorkspaceMapping> {
  return apiClient<WorkspaceMapping>(`/config/mappings/${id}`, {
    method: 'PATCH',
    body: data,
  });
}
